import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Etape1 from '../views/Tunnel-view/Etape-1.vue'
import Etape2 from '../views/Tunnel-view/Etape-2.vue'
import Etape3 from '../views/Tunnel-view/Etape-3.vue'
import Etape4 from '../views/Tunnel-view/Etape-4.vue'
import Etape5 from '../views/Tunnel-view/Etape-5.vue'
import Etape6 from '../views/Tunnel-view/Etape-6.vue'
import EtapeForm from '../views/Tunnel-view/Etape-form.vue'
import Final from '../views/Tunnel-view/Etape-final.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Etape1',
    component: Etape1
  },
  {
    path: '/Etape2',
    name: 'Etape2',
    component: Etape2
  },
  {
    path: '/Etape3',
    name: 'Etape3',
    component: Etape3
  },
  {
    path: '/Etape4',
    name: 'Etape4',
    component: Etape4
  },
  {
    path: '/Etape5',
    name: 'Etape5',
    component: Etape5
  },
  {
    path: '/Etape6',
    name: 'Etape6',
    component: Etape6
  },
  {
    path: '/Etape7',
    name: 'EtapeForm',
    component: EtapeForm
  },
  {
    path: '/Etape8',
    name: 'Final',
    component: Final
  }
]

const router = new VueRouter({
  routes,
  mode: 'abstract'
})
router.replace('/')

export default router
